const getVariantImage = async (product) => {
  const variantId = product.dataset.variantid;
  const variantGid = `gid://shopify/ProductVariant/${variantId}`;  
  const variantImage = product.querySelector('.image img');

  const query = `
    query getVariantImage($id: ID!) {
      node(id: $id) {
        ... on ProductVariant {
          image {
            url
            altText
          }
        }
      }
    }
  `;
  const variables = { id: variantGid };

  try {
    const response = await fetch('https://saharalondon-uk.myshopify.com/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '23a8e4a06e4720678fcd8ca81e9355df',
      },
      body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();
    const image = result?.data?.node?.image;

    if (image) {
      variantImage.src = image.url + '&width=500';
      variantImage.alt = image.alt || 'Product image';
    } else {
      console.warn(`No image found for this variant ${variantId}`);
    }
  } catch (error) {
    console.error('GraphQL error:', error);
  }
}

document.addEventListener('DOMContentLoaded', function () {
    const wishlistContainer = document.querySelector('.wishlistbodycontainer');
    const wishListItems = [];
    
    const handleObserver = (mutationList, observer) => {
      mutationList.forEach(function (mutation) {
        if (mutation.type === 'childList') {
            const newProducts = [...wishlistContainer.querySelectorAll('.product')].filter(product => !wishListItems.includes(product));
            newProducts.forEach(product => {
                getVariantImage(product);
                wishListItems.push(product);
            });
        }
      });
    }
    
    const observer = new MutationObserver(handleObserver);
    observer.observe(wishlistContainer, {attributes : true, childList : true, subtree : true});
});